import React, { useState } from "react";
import styles from "./styles.module.scss";
import TeamAvatar from "app/components/TeamAvatar";
import { cls } from "app/utils";
import ChannelPermissionsModal from "../ChannelPermissionsModal";
import TeamGroupModel from "app/models/TeamGroupModel";
import { GroupPermissions } from "app/models/GroupsModel";
import { useTranslation } from "react-i18next";
import { Loading } from "app/components/Wrappers";
import { Toast } from "app/components/helpers";

interface IProps {
  data: TeamGroupModel[];
  loading: boolean;
  updateData: (value: TeamGroupModel) => void;
  onRemovePermission: (data: GroupPermissions) => void;
}

const ChannelsPermissionsList = ({
  data,
  loading,
  updateData,
  onRemovePermission,
}: IProps) => {
  const { t } = useTranslation();

  const [modal, setModal] = useState<{
    open: boolean;
    channel: GroupPermissions | null;
  }>({ open: false, channel: null });

  const [toastAlert, setToastAlert] = useState(null);
  const [toastErrorAlert, setToastErrorrAlert] = useState(null);

  const openModal = (channelObj: GroupPermissions) => {
    setModal({ open: true, channel: channelObj });
  };

  const closeModal = () => {
    setModal({ open: false, channel: null });
  };

  const onSuccess = (value: GroupPermissions) => {
    closeModal();
    updateData(value);
    setToastAlert(
      t("Permissions for {{teamGroupName}} have been successfully updated.", {
        teamGroupName: value?.teamGroupName,
      }),
    );
  };

  const onError = () => {
    setToastErrorrAlert(t("Something went wrong. Please try again later"));
  };

  return (
    <ul className={styles.list_container}>
      {loading && <Loading isLoading={loading} loadType="spinner" />}
      {!loading &&
        data?.map((item: GroupPermissions) => (
          <li key={item.id} className={styles.channel}>
            <div
              className={styles.channel_content}
              onClick={() => openModal(item)}
            >
              <TeamAvatar
                srcName={null}
                altName="channel"
                className={styles.channel_avatar}
              />
              <p className={styles.channel_name}>
                {item?.teamGroupName || t("Unnamed")}
              </p>
            </div>
            <div className={styles.icons_container}>
              <i
                className={cls("ico ico-trash-outline", styles.delete_btn)}
                onClick={() => onRemovePermission(item)}
              />
              <hr className={styles.border} />
              <i
                className={cls("ico ico-chevron", styles.arrow_icon)}
                onClick={() => openModal(item)}
              />
            </div>
          </li>
        ))}

      <Toast
        success={toastAlert}
        error={toastErrorAlert}
        onDone={() => setToastAlert(null)}
      />

      {modal.open && modal.channel && (
        <ChannelPermissionsModal
          isOpen={modal.open}
          onCloseFunc={closeModal}
          channelDataProps={modal.channel}
          onSaveChannelPermissions={onSuccess}
          onErrorSavingPermissions={onError}
        />
      )}
    </ul>
  );
};

export default ChannelsPermissionsList;
